import { api, apiAxiosInstance } from './api';

export const fetchImages = (params) => {
  return api.get(`/file`, params);
};

export const uploadImage = (payload) => {
  return api.post(`/file/image`, payload, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

export const updateImage = (payload) => {
  return api.put(`/file/image`, payload);
};

export const deleteImage = (payload) => {
  return apiAxiosInstance
    .delete(`/file/image`, {
      data: payload,
    })
    .catch((err) => {
      return err.response;
    });
};
